'use client'
import styles from "./collection.module.css"
import { useRow } from "@/apiUtilities/queries/useRow"
import GameCard, { CardType } from "@/components/UI/GameCard/GameCard"
import { useWindowSize } from "@/hooks/useWindowsSize"
import { useUserStore } from "@/stores/useUserStore"
import { useLocale } from "next-intl"

export default function Collection({ id } : { id : string}) {
    const locale = useLocale()
    const { userId, profileId } = useUserStore()
    const { data: row, isSuccess } = useRow({ id, locale, profileId })
    const { width } = useWindowSize()

    return (
        isSuccess && <div className={styles.main} data-testid="Collection">
            {row.title && <h1 className="title2" data-testid="Collection_title">{row.title}</h1>}
            {row.subtitle && <p className="bodyTextMedium" data-testid="Collection_subtitle">{row.subtitle}</p>}
            <div className={styles.games} data-testid="Collection_games">
                {row.content.map((game, idx) => <GameCard analyticsRow={id} analyticsRowName={row.title} analyticsIndex={idx} analyticsModule={'row_page'} type={width > 1024 ? CardType.Horizontal : CardType.Vertical } game={game} key={game.game_id}/>)}
            </div>
        </div>
    )
}